import { Box, Typography } from '@mui/material'
import { toLongDate } from '~/util/date'
import {
  MESSAGES,
  campaignNoDataNotice,
  campaignNoRowsNotice,
} from '~/components/Charts/chrome/chartChrome'

interface Props {
  fromIso: string
  toIso: string
  context: 'primary' | 'compare'
  /** I1b blank case: the active campaign's display label, or null/absent when no campaign
   *  predicate is active. When set, the campaign notice LEADS the existing window copy below
   *  (a merge, not a replacement) — the window/adjust-hint lines always stay. */
  campaignLabel?: string | null
  /** D-FEW-5: sharper variant of the campaign notice — the fact carries the Campaign dim but no
   *  row is tagged with THIS campaign's id. Default false ⇒ byte-identical to before this prop
   *  existed. */
  campaignHasNoRows?: boolean
}

export function EmptyChartState({
  fromIso,
  toIso,
  context,
  campaignLabel,
  campaignHasNoRows,
}: Props) {
  const label = context === 'compare' ? MESSAGES.windowLabelCompare : MESSAGES.windowLabelPrimary
  const range = `${toLongDate(fromIso)} – ${toLongDate(toIso)}`
  return (
    <Box sx={{ p: 4, textAlign: 'center', color: 'text.secondary' }}>
      {campaignLabel ? (
        <Typography variant="body2" gutterBottom>
          {campaignHasNoRows
            ? campaignNoRowsNotice(campaignLabel)
            : campaignNoDataNotice(campaignLabel)}
        </Typography>
      ) : null}
      <Typography variant="body2" gutterBottom>
        {MESSAGES.noDataInWindow(label, range)}
      </Typography>
      <Typography variant="caption">{MESSAGES.adjustWindowHint(label)}</Typography>
    </Box>
  )
}
